let globals = {
  apiHost: '',
  parentOrigin: '',
  apiHostBot: '',
  apiHostFiles: '',
}

export default globals
